(function () {
  'use strict';

  // ── Data ────────────────────────────────────────────────────────────
  const SCENTS = [
    // hotel
    { id:'four-seasons',  name:'Four Seasons',      cat:'hotel',     he:'פור סיזנס',        notes:'יסמין · ארז · מוסק לבן',          mood:'יוקרתי, מרגיע',       accent:'#d4c4a8' },
    { id:'setai',         name:'The Setai',          cat:'hotel',     he:'דה סֶטַאי',        notes:'תה ירוק · לוטוס · ג\'ינג\'ר',     mood:'מינימליסטי, אסייתי',  accent:'#b8d4b8' },
    { id:'royal-beach',   name:'Royal Beach',        cat:'hotel',     he:'רויאל ביץ\'',      notes:'מי ים · אקוה · עץ סחף',          mood:'ים, חופש',            accent:'#a8c4d4' },
    { id:'beresheet',     name:'Beresheet',          cat:'hotel',     he:'בראשית',            notes:'ורד מדבר · עוּד · ענבר',          mood:'מסתורי, חמים',        accent:'#d4a888' },
    { id:'hilton',        name:'Hilton',             cat:'hotel',     he:'הילטון',            notes:'פשתן · עץ-תה · וניל',            mood:'נקי, מקצועי',         accent:'#c8c8c8' },
    // fresh
    { id:'ocean',         name:'Ocean Breeze',       cat:'fresh',     he:'רוח ים',            notes:'מי ים · אקליפטוס · נענע',        mood:'מרענן, קליל',         accent:'#88c8c0' },
    { id:'citrus',        name:'Citrus Grove',       cat:'fresh',     he:'חורשת הדרים',       notes:'לימון · אשכולית · ברגמוט',       mood:'אנרגטי, בהיר',        accent:'#e0d050' },
    { id:'zen',           name:'Zen Garden',         cat:'fresh',     he:'גן זן',             notes:'במבוק · תה לבן · קמומיל',        mood:'מרגיע, מינימליסטי',   accent:'#98c888' },
    // masculine
    { id:'dark-oud',      name:'Dark Oud',           cat:'masculine', he:'עוּד כהה',          notes:'עוּד · וטיבר · פלפל שחור',       mood:'אינטנסיבי, ייחודי',   accent:'#5a3a20' },
    { id:'forest',        name:'Midnight Forest',    cat:'masculine', he:'יער חצות',          notes:'ארז · אורן · אדמה לחה',         mood:'גברי, יערי',          accent:'#2a4020' },
    { id:'executive',     name:'Executive',          cat:'masculine', he:'אקזקיוטיב',         notes:'קפה · עור · טבק קר',            mood:'מקצועי, חזק',         accent:'#3a2010' },
    // sweet
    { id:'velvet-rose',   name:'Velvet Rose',        cat:'sweet',     he:'ורד קטיפה',         notes:'ורד · פיוני · וניל חם',         mood:'רומנטי, נשי',         accent:'#e8a8b8' },
    { id:'sweet-amber',   name:'Sweet Amber',        cat:'sweet',     he:'ענבר מתוק',         notes:'וניל · בנזואין · קרמל',         mood:'חמים, מפנק',          accent:'#e8c888' },
    { id:'cherry',        name:'Cherry Blossom',     cat:'sweet',     he:'פרחי דובדבן',       notes:'אפרסק · פרחי דובדבן · מוסק',   mood:'עדין, יפני',          accent:'#f0b8c8' },
    // fruity
    { id:'tropical',      name:'Tropical Paradise',  cat:'fruity',    he:'גן עדן טרופי',      notes:'מנגו · קוקוס · פסיפלורה',       mood:'טרופי, קיצי',         accent:'#e8d040' },
    { id:'fresh-fig',     name:'Fresh Fig',          cat:'fruity',    he:'תאנה טרייה',        notes:'תאנה · אגס · ברגמוט',           mood:'ים-תיכוני, רענן',     accent:'#c8a8d8' },
    { id:'berry',         name:'Berry Garden',       cat:'fruity',    he:'גן פירות יער',      notes:'פטל · תות שדה · היביסקוס',     mood:'ססגוני, שמח',         accent:'#d060a0' },
  ];

  const BOTTLES = [
    { id:'square', label:'קלאסי',  sub:'150 מ"ל · ריבועי',  price:109 },
    { id:'round',  label:'עגול',   sub:'150 מ"ל · כדורי',   price:119 },
    { id:'tall',   label:'מגדל',   sub:'200 מ"ל · גבוה',    price:129 },
    { id:'hex',    label:'הקסגון', sub:'180 מ"ל · שישה-צלעי', price:139 },
  ];

  const COLORS = [
    { id:'clear', label:'שקוף',     hex:'rgba(180,210,230,0.55)', stroke:'rgba(120,170,200,0.9)',  labelText:'rgba(20,40,80,0.92)',   glass:'rgba(255,255,255,0.38)' },
    { id:'black', label:'שחור מאט', hex:'#1c1c1c',               stroke:'#333',                   labelText:'rgba(255,255,255,0.9)', glass:'rgba(255,255,255,0.07)' },
    { id:'white', label:'לבן פנינה',hex:'#f2f0ec',               stroke:'#d0cec8',                labelText:'rgba(40,40,40,0.9)',    glass:'rgba(255,255,255,0.55)' },
    { id:'rose',  label:'ורוד זהב', hex:'#d4a8a8',               stroke:'#c09090',                labelText:'rgba(70,20,30,0.9)',    glass:'rgba(255,255,255,0.28)' },
    { id:'navy',  label:'כחול לילה',hex:'#1a2744',               stroke:'#253055',                labelText:'rgba(255,255,255,0.9)', glass:'rgba(255,255,255,0.1)'  },
    { id:'sage',  label:'ירוק זית', hex:'#6a8870',               stroke:'#507060',                labelText:'rgba(255,255,255,0.9)', glass:'rgba(255,255,255,0.18)' },
  ];

  const LABELS = [
    { id:'sensei',   label:'SENSEI קלאסי',     custom:false, image:false },
    { id:'monogram', label:'ראשי תיבות',        custom:true,  image:false },
    { id:'brand',    label:'שם / מותג אישי',   custom:true,  image:false },
    { id:'image',    label:'תמונה / לוגו',  custom:false, image:true  },
    { id:'minimal',  label:'ללא לוגו',          custom:false, image:false },
  ];

  const OCCASIONS = [
    { id:'personal', label:'שימוש אישי' },
    { id:'gift',     label:'מתנה' },
    { id:'business', label:'עסקי / חברה' },
  ];

  // ── State ────────────────────────────────────────────────────────────
  const state = { scent:null, bottle:null, color:null, label:null, customText:'', occasion:null, step:1, uploadedImage:null };

  // ── SVG Bottle Generator ─────────────────────────────────────────────
  function reeds(cx, y) {
    const angles = [-38,-18,0,18,38];
    return angles.map((a,i) => {
      const r = a * Math.PI / 180;
      const len = 82 + (i%2)*12;
      const x2 = (cx + Math.sin(r)*len).toFixed(1);
      const y2 = (y - Math.cos(r)*len).toFixed(1);
      return `<line x1="${cx+(i-2)*4}" y1="${y}" x2="${x2}" y2="${y2}" stroke="#b8a070" stroke-width="1.9" stroke-linecap="round" opacity="0.82"/>`;
    }).join('');
  }

  const SHAPES = {
    square: {
      vb:'0 0 140 290', cx:70, ry:50,
      stopper:[46,52,48,17,4],
      neck:[54,69,32,38,3],
      body:'M24,105Q24,98 31,98L109,98Q116,98 116,105L116,262Q116,269 109,269L31,269Q24,269 24,262Z',
      glass:[28,103,12,160,4],
      lbl:[32,124,76,86,2], bY:162, sY:180,
    },
    round: {
      vb:'0 0 140 300', cx:70, ry:54,
      stopper:[50,50,40,16,4],
      neck:[57,66,26,40,3],
      body:'M70,104 m-54,0 a54,68 0 1,0 108,0 a54,68 0 1,0 -108,0',
      glass:null, glassPath:'M32,118 Q28,145 32,165 Q44,107 54,104',
      lbl:[28,148,84,52,26], bY:173, sY:190,
    },
    tall: {
      vb:'0 0 140 320', cx:70, ry:42,
      stopper:[50,45,40,16,4],
      neck:[57,61,26,36,3],
      body:'M38,95Q38,89 44,89L96,89Q102,89 102,95L102,300Q102,306 96,306L44,306Q38,306 38,300Z',
      glass:[42,93,10,208,3],
      lbl:[44,118,52,82,2], bY:157, sY:174,
    },
    hex: {
      vb:'0 0 140 290', cx:70, ry:50,
      stopper:[47,50,46,17,4],
      neck:[55,67,30,36,3],
      body:'M70,101L116,125L116,247L70,271L24,247L24,125Z',
      glass:[28,110,10,148,2],
      lbl:[30,130,80,80,4], bY:163, sY:180,
    },
  };

  function buildSVG(shapeId, colorId, brandText, scentName, imageDataUrl) {
    const s = SHAPES[shapeId] || SHAPES.square;
    const c = COLORS.find(x => x.id === colorId) || COLORS[0];
    const brand = (brandText || 'SENSEI').toUpperCase().substring(0,16);
    const scent = scentName || '';
    const gid = `g${shapeId}${colorId}`;

    const glassEl = s.glass
      ? `<rect x="${s.glass[0]}" y="${s.glass[1]}" width="${s.glass[2]}" height="${s.glass[3]}" rx="${s.glass[4]}" fill="${c.glass}"/>`
      : s.glassPath ? `<path d="${s.glassPath}" fill="${c.glass}" stroke="none"/>` : '';

    const lbl = s.lbl; // [x, y, w, h, rx]
    const lblStroke = c.labelText === 'rgba(40,40,40,0.9)' ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.14)';
    const pad = 5;

    // Label content: image OR text
    const labelContent = imageDataUrl
      ? `<clipPath id="ic${gid}"><rect x="${lbl[0]+pad}" y="${lbl[1]+pad}" width="${lbl[2]-pad*2}" height="${lbl[3]-pad*2}" rx="${lbl[4]}"/></clipPath>
  <image href="${imageDataUrl}" x="${lbl[0]+pad}" y="${lbl[1]+pad}" width="${lbl[2]-pad*2}" height="${lbl[3]-pad*2}" preserveAspectRatio="xMidYMid meet" clip-path="url(#ic${gid})"/>
  <text x="${s.cx}" y="${lbl[1]+lbl[3]+11}" text-anchor="middle" font-family="'Noto Sans Hebrew',sans-serif" font-size="7" letter-spacing="1.2" fill="${c.labelText}" opacity="0.6">${scent.toUpperCase()}</text>`
      : `<text x="${s.cx}" y="${s.bY}" text-anchor="middle" font-family="Georgia,serif" font-size="10.5" font-weight="400" letter-spacing="4.5" fill="${c.labelText}">${brand}</text>
  <text x="${s.cx}" y="${s.sY}" text-anchor="middle" font-family="'Noto Sans Hebrew',sans-serif" font-size="7.5" letter-spacing="1.4" fill="${c.labelText}" opacity="0.68">${scent.toUpperCase()}</text>`;

    return `<svg viewBox="${s.vb}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="filter:drop-shadow(0 10px 32px rgba(0,0,0,0.26));overflow:visible">
  <defs>
    <linearGradient id="${gid}" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="${c.stroke}" stop-opacity="0.75"/>
      <stop offset="45%" stop-color="${c.hex}"/>
      <stop offset="100%" stop-color="${c.stroke}" stop-opacity="0.6"/>
    </linearGradient>
  </defs>
  ${reeds(s.cx, s.stopper[1]+2)}
  <rect x="${s.stopper[0]}" y="${s.stopper[1]}" width="${s.stopper[2]}" height="${s.stopper[3]}" rx="${s.stopper[4]}" fill="rgba(0,0,0,0.78)"/>
  <rect x="${s.neck[0]}" y="${s.neck[1]}" width="${s.neck[2]}" height="${s.neck[3]}" rx="${s.neck[4]}" fill="url(#${gid})" stroke="${c.stroke}" stroke-width="0.7"/>
  <path d="${s.body}" fill="url(#${gid})" stroke="${c.stroke}" stroke-width="1"/>
  ${glassEl}
  <rect x="${lbl[0]}" y="${lbl[1]}" width="${lbl[2]}" height="${lbl[3]}" rx="${lbl[4]}" fill="rgba(255,255,255,${imageDataUrl ? '0.92' : '0.10'})" stroke="${lblStroke}" stroke-width="0.6"/>
  ${labelContent}
  <ellipse cx="${s.cx}" cy="${parseInt(s.vb.split(' ')[3])-10}" rx="${s.ry}" ry="${Math.round(s.ry*0.22)}" fill="rgba(0,0,0,0.10)"/>
</svg>`;
  }

  // ── Render helpers ───────────────────────────────────────────────────
  function updatePreview() {
    const preview = document.getElementById('bottle-preview');
    const info    = document.getElementById('preview-info');
    const priceEl = document.getElementById('preview-price');
    if (!preview) return;

    const scent  = SCENTS.find(s => s.id === state.scent);
    const bottle = BOTTLES.find(b => b.id === state.bottle);
    const color  = state.color || 'clear';
    const brand  = state.label === 'sensei'   ? 'SENSEI'
                 : state.label === 'minimal'  ? ''
                 : state.label === 'image'    ? ''
                 : state.customText           || (state.label === 'monogram' ? 'AB' : 'שם');

    if (!scent) return;

    const shape = state.bottle || 'square';
    preview.innerHTML = buildSVG(shape, color, brand, scent.he || scent.name, state.uploadedImage);

    if (info) {
      info.style.display = 'flex';
      document.getElementById('preview-scent-name').textContent = scent.he + ', ' + scent.name;
      document.getElementById('preview-notes').textContent = scent.notes;
      document.getElementById('preview-mood').textContent = scent.mood;
    }
    if (priceEl && bottle) {
      priceEl.style.display = 'block';
      priceEl.textContent = '₪' + bottle.price;
    }
  }

  function renderScents(cat) {
    const grid = document.getElementById('scent-grid');
    if (!grid) return;
    const list = cat === 'all' ? SCENTS : SCENTS.filter(s => s.cat === cat);
    grid.innerHTML = list.map(s => `
      <div class="snsei-cfg__scent-card ${state.scent === s.id ? 'selected':''}" data-scent="${s.id}" style="--accent:${s.accent}">
        <div class="snsei-cfg__scent-accent"></div>
        <strong class="snsei-cfg__scent-he">${s.he}</strong>
        <span class="snsei-cfg__scent-en">${s.name}</span>
        <span class="snsei-cfg__scent-notes">${s.notes}</span>
        <span class="snsei-cfg__scent-mood">${s.mood}</span>
      </div>`).join('');

    grid.querySelectorAll('.snsei-cfg__scent-card').forEach(el => {
      el.addEventListener('click', () => {
        state.scent = el.dataset.scent;
        grid.querySelectorAll('.snsei-cfg__scent-card').forEach(c => c.classList.remove('selected'));
        el.classList.add('selected');
        document.querySelector('[data-panel="1"] .snsei-cfg__next').disabled = false;
        updatePreview();
      });
    });
  }

  function renderBottles() {
    const grid = document.getElementById('bottle-grid');
    if (!grid) return;
    grid.innerHTML = BOTTLES.map(b => `
      <div class="snsei-cfg__bottle-card ${state.bottle === b.id ? 'selected':''}" data-bottle="${b.id}">
        <div class="snsei-cfg__bottle-mini" id="mini-${b.id}"></div>
        <strong>${b.label}</strong>
        <span>${b.sub}</span>
        <span class="snsei-cfg__bottle-price">₪${b.price}</span>
      </div>`).join('');

    // Mini previews
    BOTTLES.forEach(b => {
      const el = document.getElementById('mini-' + b.id);
      if (el) el.innerHTML = buildSVG(b.id, state.color || 'clear', 'S', '');
    });

    grid.querySelectorAll('.snsei-cfg__bottle-card').forEach(el => {
      el.addEventListener('click', () => {
        state.bottle = el.dataset.bottle;
        grid.querySelectorAll('.snsei-cfg__bottle-card').forEach(c => c.classList.remove('selected'));
        el.classList.add('selected');
        document.querySelector('[data-panel="2"] .snsei-cfg__next').disabled = false;
        updatePreview();
      });
    });
  }

  function renderColors() {
    const grid = document.getElementById('color-grid');
    if (!grid) return;
    grid.innerHTML = COLORS.map(c => `
      <div class="snsei-cfg__color-swatch ${state.color === c.id ? 'selected':''}" data-color="${c.id}" title="${c.label}">
        <span class="snsei-cfg__color-dot" style="background:${c.hex};border:2px solid ${c.stroke}"></span>
        <span>${c.label}</span>
      </div>`).join('');

    grid.querySelectorAll('.snsei-cfg__color-swatch').forEach(el => {
      el.addEventListener('click', () => {
        state.color = el.dataset.color;
        grid.querySelectorAll('.snsei-cfg__color-swatch').forEach(c => c.classList.remove('selected'));
        el.classList.add('selected');
        document.querySelector('[data-panel="3"] .snsei-cfg__next').disabled = false;
        updatePreview();
        // Refresh bottle minis
        BOTTLES.forEach(b => {
          const mini = document.getElementById('mini-' + b.id);
          if (mini) mini.innerHTML = buildSVG(b.id, state.color, 'S', '');
        });
      });
    });
  }

  function renderLabels() {
    const grid = document.getElementById('label-grid');
    if (!grid) return;
    grid.innerHTML = LABELS.map(l => `
      <div class="snsei-cfg__label-card ${state.label === l.id ? 'selected':''}" data-label="${l.id}">
        ${l.label}
      </div>`).join('');

    grid.querySelectorAll('.snsei-cfg__label-card').forEach(el => {
      el.addEventListener('click', () => {
        state.label = el.dataset.label;
        grid.querySelectorAll('.snsei-cfg__label-card').forEach(c => c.classList.remove('selected'));
        el.classList.add('selected');
        const def = LABELS.find(l => l.id === state.label);
        const textWrap  = document.getElementById('custom-text-wrap');
        const imageWrap = document.getElementById('image-upload-wrap');
        if (textWrap)  textWrap.style.display  = def?.custom  ? 'block' : 'none';
        if (imageWrap) imageWrap.style.display = def?.image   ? 'block' : 'none';
        // Clear image if switching away from image label
        if (!def?.image && state.uploadedImage) {
          state.uploadedImage = null;
          const prev = document.getElementById('upload-preview');
          const zone = document.getElementById('upload-zone');
          if (prev) prev.style.display = 'none';
          if (zone) zone.style.display = 'flex';
        }
        updatePreview();
      });
    });
  }

  function renderOccasions() {
    const grid = document.getElementById('occasion-grid');
    if (!grid) return;
    grid.innerHTML = OCCASIONS.map(o => `
      <div class="snsei-cfg__occasion-card ${state.occasion === o.id ? 'selected':''}" data-occasion="${o.id}">
        ${o.label}
      </div>`).join('');

    grid.querySelectorAll('.snsei-cfg__occasion-card').forEach(el => {
      el.addEventListener('click', () => {
        state.occasion = el.dataset.occasion;
        grid.querySelectorAll('.snsei-cfg__occasion-card').forEach(c => c.classList.remove('selected'));
        el.classList.add('selected');
      });
    });
  }

  function renderSummary() {
    const box = document.getElementById('summary-box');
    const priceEl = document.getElementById('final-price');
    if (!box) return;
    const scent  = SCENTS.find(s => s.id === state.scent);
    const bottle = BOTTLES.find(b => b.id === state.bottle);
    const color  = COLORS.find(c => c.id === state.color);
    const occ    = OCCASIONS.find(o => o.id === state.occasion);
    const labelDesc = state.label === 'sensei'  ? 'SENSEI קלאסי'
                    : state.label === 'minimal' ? 'ללא לוגו'
                    : state.label === 'image'   ? 'תמונה / לוגו אישי'
                    : state.customText || ', ';

    box.innerHTML = `
      <div class="snsei-cfg__sum-row"><span>ניחוח</span><strong>${scent?.he || ', '} <em>(${scent?.name || ''})</em></strong></div>
      <div class="snsei-cfg__sum-row"><span>צורת בקבוק</span><strong>${bottle?.label || ', '}</strong></div>
      <div class="snsei-cfg__sum-row"><span>צבע</span><strong>${color?.label || ', '}</strong></div>
      <div class="snsei-cfg__sum-row"><span>תווית</span><strong>${labelDesc}</strong></div>
      <div class="snsei-cfg__sum-row"><span>מיועד ל</span><strong>${occ?.label || ', '}</strong></div>
      <div class="snsei-cfg__sum-row"><span>נרות ריד</span><strong>5 קנים · 150 מ"ל שמן</strong></div>`;

    if (priceEl && bottle) priceEl.textContent = '₪' + bottle.price;
  }

  // ── Navigation ───────────────────────────────────────────────────────
  function goTo(step) {
    document.querySelectorAll('.snsei-cfg__panel').forEach(p => p.classList.remove('active'));
    const panel = document.querySelector('[data-panel="' + step + '"]');
    if (panel) panel.classList.add('active');

    document.querySelectorAll('.snsei-cfg__prog-step').forEach(s => {
      const n = parseInt(s.dataset.step);
      s.classList.toggle('active',  n === step);
      s.classList.toggle('done',    n < step);
    });

    state.step = step;
    if (step === 2) renderBottles();
    if (step === 3) renderColors();
    if (step === 4) { renderLabels(); renderOccasions(); }
    if (step === 5) { renderSummary(); updatePreview(); }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // ── Cart ─────────────────────────────────────────────────────────────
  function addToCart() {
    const scent  = SCENTS.find(s => s.id === state.scent);
    const bottle = BOTTLES.find(b => b.id === state.bottle);
    const color  = COLORS.find(c => c.id === state.color);
    const label  = LABELS.find(l => l.id === state.label);
    const occ    = OCCASIONS.find(o => o.id === state.occasion);
    const variantId = window.SNSEI_VARIANTS?.[state.bottle] || window.SNSEI_VARIANTS?.square;

    const properties = {
      'ניחוח':     (scent?.he  || '') + ' (' + (scent?.name || '') + ')',
      'בקבוק':     bottle?.label || '',
      'צבע':       color?.label || '',
      'תווית':     label?.label || '',
      'טקסט אישי': state.customText || '',
      'מיועד ל':   occ?.label || '',
    };

    const btn = document.getElementById('add-to-cart-btn');
    btn.disabled = true;
    btn.textContent = 'מוסיף...';

    fetch('/cart/add.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties }),
    })
    .then(r => r.json())
    .then(d => {
      if (d.id || d.variant_id) {
        const fb = document.getElementById('cart-feedback');
        if (fb) fb.style.display = 'block';
        btn.textContent = 'נוסף לסל';
      } else {
        btn.disabled = false;
        btn.textContent = 'הוסף לסל';
        alert('שגיאה בהוספה לסל. נסה שוב.');
      }
    })
    .catch(() => {
      btn.disabled = false;
      btn.textContent = 'הוסף לסל';
    });
  }

  // ── Init ─────────────────────────────────────────────────────────────
  function init() {
    // Render scents
    renderScents('all');

    // Category tabs
    document.querySelectorAll('.snsei-cfg__cat').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.snsei-cfg__cat').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        renderScents(btn.dataset.cat);
      });
    });

    // Next/Back buttons
    document.querySelectorAll('.snsei-cfg__next').forEach(btn => {
      btn.addEventListener('click', () => goTo(parseInt(btn.dataset.to)));
    });
    document.querySelectorAll('.snsei-cfg__back').forEach(btn => {
      btn.addEventListener('click', () => goTo(parseInt(btn.dataset.to)));
    });

    // Finish button
    const finishBtn = document.getElementById('finish-btn');
    if (finishBtn) finishBtn.addEventListener('click', () => {
      if (!state.label) state.label = 'sensei';
      if (!state.occasion) state.occasion = 'personal';
      goTo(5);
    });

    // Custom text input
    const textInput = document.getElementById('custom-text-input');
    if (textInput) textInput.addEventListener('input', () => {
      state.customText = textInput.value;
      updatePreview();
    });

    // File upload
    const fileInput = document.getElementById('logo-file-input');
    if (fileInput) {
      fileInput.addEventListener('change', function() {
        const file = this.files[0];
        if (!file || file.size > 2 * 1024 * 1024) return;
        const reader = new FileReader();
        reader.onload = e => {
          state.uploadedImage = e.target.result;
          const thumb = document.getElementById('uploaded-img-thumb');
          const prev  = document.getElementById('upload-preview');
          const zone  = document.getElementById('upload-zone');
          if (thumb) thumb.src = e.target.result;
          if (prev)  prev.style.display = 'flex';
          if (zone)  zone.style.display = 'none';
          updatePreview();
        };
        reader.readAsDataURL(file);
      });
    }
    const removeLogo = document.getElementById('remove-logo');
    if (removeLogo) {
      removeLogo.addEventListener('click', () => {
        state.uploadedImage = null;
        const thumb = document.getElementById('uploaded-img-thumb');
        const prev  = document.getElementById('upload-preview');
        const zone  = document.getElementById('upload-zone');
        const fi    = document.getElementById('logo-file-input');
        if (thumb) thumb.src = '';
        if (prev)  prev.style.display = 'none';
        if (zone)  zone.style.display = 'flex';
        if (fi)    fi.value = '';
        updatePreview();
      });
    }

    // WhatsApp share
    const waBtn = document.getElementById('wa-share-btn');
    if (waBtn) {
      waBtn.addEventListener('click', () => {
        const scent  = SCENTS.find(s => s.id === state.scent);
        const bottle = BOTTLES.find(b => b.id === state.bottle);
        const color  = COLORS.find(c => c.id === state.color);
        const occ    = OCCASIONS.find(o => o.id === state.occasion);
        const labelDesc = state.label === 'sensei'  ? 'SENSEI קלאסי'
                        : state.label === 'minimal' ? 'ללא לוגו'
                        : state.label === 'image'   ? 'תמונה / לוגו אישי'
                        : state.customText || 'אישי';
        const msg = [
          'עיצבתי מפיץ ריח ב-SENSEI',
          '',
          'ניחוח: ' + (scent?.he || ', ') + ' (' + (scent?.name || '') + ')',
          'בקבוק: ' + (bottle?.label || ', ') + ' · ' + (color?.label || ', '),
          'תווית: ' + labelDesc,
          'מיועד ל: ' + (occ?.label || ', '),
          '',
          '👇 צור גם אתה:',
          window.location.origin + '/pages/custom-diffuser',
        ].join('\n');
        window.open('https://api.whatsapp.com/send?text=' + encodeURIComponent(msg), '_blank');
      });
    }

    // Add to cart
    const cartBtn = document.getElementById('add-to-cart-btn');
    if (cartBtn) cartBtn.addEventListener('click', addToCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
